/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Trial_TitleInputs */



/**
* | output |
* | --- |
* | "Trial Mode" |
*
* @param {Video_Export_Trial_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_trial_title = /** @type {((inputs?: Video_Export_Trial_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Trial_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode d'essai")
	if (locale === "de") return /** @type {LocalizedString} */ ("Testmodus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità di prova")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пробный режим")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de prueba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("试用模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トライアルモード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परीक्षण मोड़")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo de teste")
	return /** @type {LocalizedString} */ ("Trial Mode")
});